module.exports = __webpack_public_path__ + "media/theme/border-7-db9dc6d4.png";